import { CircleHelp } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'

export function FactsHelp() {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="ghost" className="cursor-pointer">
          <CircleHelp className="size-4" aria-hidden="true" />
          Facts
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="end"
        aria-label="About facts"
        className="max-h-[var(--radix-popover-content-available-height)] w-80 max-w-[calc(100vw-2rem)] space-y-3 overflow-y-auto text-sm text-muted-foreground">
        <ul className="list-disc space-y-3 pl-4">
          <li>
            Facts come from the selected member or the client organization.
          </li>
          <li>
            Supported types include text, dates, numbers, and true/false values.
          </li>
          <li>Each fact must be compatible with its field type.</li>
          <li>
            Dates use MM/DD/YYYY. Numbers use plain text. True/false values
            appear as Yes/No in text fields or checked/unchecked in checkboxes.
          </li>
          <li>Facts that require a specific duty or call are omitted.</li>
          <li>
            For an unsupported value type or a different display format, create
            a derived fact that returns formatted text.
          </li>
        </ul>
      </PopoverContent>
    </Popover>
  )
}
